export default {
  "title": "FreeDive Ai",
  "heroHeadline": "Entraînez-vous tous les jours et améliorez vos compétences en apnée !",
  "heroSubheadline": "L'application ultime d'entraînement à l'apnée par IA pour les apnéistes, chasseurs sous-marins et sirènes.",
  "featuresHeader": "Pourquoi choisir FreeDive Ai ?",
  "featuresSubtitle": "Tout ce dont vous avez besoin pour plonger plus profondément, retenir votre respiration plus longtemps et rester en sécurité.",
  "feature1Title": "Entraînement d'Apnée par IA",
  "feature1Desc": "Tables personnalisées de CO2 et O2 générées par l'IA en fonction de vos records personnels pour augmenter vos temps d'apnée en toute sécurité.",
  "feature2Title": "Carnet de Plongée Intelligent",
  "feature2Desc": "Enregistrez vos sessions d'apnée et de chasse sous-marine. Suivez les profondeurs, les temps, la fréquence cardiaque et la SpO2 au même endroit.",
  "feature3Title": "Compétitions et Licences",
  "feature3Desc": "Gardez une trace de vos licences d'apnée et restez informé des compétitions et événements mondiaux.",
  "screenshotsTitle": "Captures d'écran de l'application",
  "copyright": "© DomiLabs. All rights reserved."
};
